export default __webpack_public_path__ + "static/media/ScannerStationGantry.b315dba8.svg";